import { useCallback as m, useMemo as u } from "react";
import { a as w } from "../add-DH4DZT_w.mjs";
import { f } from "../format-DF9p-6BI.mjs";
const a = /* @__PURE__ */ new Date(), g = async ({
  programId: r,
  programType: o = "series",
  SCHEDULE_ENDPOINT: i,
  NETWORK: n
}) => {
  const c = m(async (e, d, s, l) => {
    const y = /* @__PURE__ */ new Map([
      ["series", `series_prefix__icontains=${e}`],
      ["film", `title_code__iexact=${e}`]
    ]), _ = `${s}/${l}?ordering=start_ts_parse&${y.get(d)}&start_date__range=${f(a, "yyyy-MM-dd")},${f(w(a, { days: 14 }), "yyyy-MM-dd")}&limit=20`;
    try {
      const t = await fetch(_);
      if (t != null && t.ok)
        return await t.json();
      console.log(`An error was returned from fetch. HTTP Response Code: ', ${t == null ? void 0 : t.status}`);
    } catch (t) {
      console.log("Fetch failed with error:", t);
    }
  }, []);
  return await u(async () => await (await c(r, o, i, n)).results.filter((s) => s.start_ts_parse * 1e3 > a.valueOf()), [c, r, o, i, n]);
};
export {
  g as default
};
